const states = {
  findCoaches: 'find-coaches',
  reviewCoaches: 'review-coaches',
  bookCoach: 'book-coach',
  projectRunning: 'project-running',
  projectFinished: 'project-finished',
};

export default states;
